<template>
  <div class="inputbox f-l" :class="{ 'not-matched': inputValue && !isEqual }" @click="clickInput()">
    <span v-if="label" class="label">{{ label }}</span>
    <span v-if="unit" class="unit">{{ unit }}</span>
    <div class="input year">
      <span :style="{'opacity': isEqual ? '0' : '100'}">{{ guideValue | toCurrency }}</span>
      <input
        type="tel"
        ref="input"
        @input="checkValue"
        v-input-currency="inputValue"
        :style="{
          'color': isEqual ? '#1baaf1' : '#333333',
          'font-weight': isEqual ? 600 : 500}"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: null
    },
    unit: {
      type: String,
      default: null
    },
    guideValue: {
      type: Number,
      required: true
    },
    isEqual: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      inputValue: null
    }
  },
  methods: {
    clickInput() {
      this.$refs.input.focus()
    },
    checkValue(e) {
      let newValue = e.target.value
      if (newValue) {
        // 숫자 외 모든 문자 제거
        newValue = this.$options.filters.commaRemove(e.target.value)
        // guideValue 길이만큼만 입력 가능하게 제한
        newValue = newValue.substring(0, this.guideValue.toString().length)
        // Number로 변환
        newValue = Number(newValue)
      }
      this.inputValue = newValue
      this.$emit('update:isEqual', this.inputValue === this.guideValue)
    }
  }
}
</script>
<style lang="scss" scoped>
.inputbox {
  display: inline-block;
  // width: calc(50% - 8px);
  width: 100%;
  height: 48px;
  line-height: 48px;
  border-radius: 4px;
  border: solid 1px #d7e1ea;
  background-color: #ffffff;

  // padding-left: 15px;
  padding-right: 15px;

  &.not-matched {
    border: solid 1px #ff1616;
  }

  .label {
    float: left;
  }
  .input {
    // display: inline-block;
    margin-right: 5px;
    text-align: left;
    line-height: 48px;
    height: 48px;
    float: right;
    span {
      display: inline-block;
      height: 100%;
      text-align: left;
      color: #8a94a2;
      font-weight: 400;
      z-index: 1;
    }
    input {
      display: inline-block;
      position: absolute;
      min-width: 200%;
      height: 100%;
      top: 0;
      left: 0;
      padding: 0;
      background: none;
      z-index: 2;
      overflow: visible;
    }
  }
  .unit {
    float: right;
  }

  div, span, input {
    display: inline-block;
  }
}
</style>
